import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseHttpService } from '../../../shared/services/base-http.service';
import { CONTROLLER_CONSTANTS } from '../../../shared/constants/controller.constants';
import { ENDPOINT_CONSTANTS } from '../../../shared/constants/endpoint.constants';
import { LoginRequest, LoginResponse, ForgotPasswordRequest, ForgotPasswordResponse, ChangePasswordRequest, ChangePasswordResponse, SendPasswordRequest } from '../../../shared/interfaces/login.interface';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(private baseHttp: BaseHttpService) { }

  login(credentials: LoginRequest): Observable<LoginResponse> {
    const endpoint = `/${CONTROLLER_CONSTANTS.ACCOUNT}/${ENDPOINT_CONSTANTS.AUTHENTICATE}`;
    return this.baseHttp.post<LoginResponse>(endpoint, credentials, true);
  }

  forgotPassword(request: ForgotPasswordRequest): Observable<ForgotPasswordResponse> {
    const endpoint = `/${CONTROLLER_CONSTANTS.ACCOUNT}/${ENDPOINT_CONSTANTS.FORGOT_PASSWORD}`;
    return this.baseHttp.post<ForgotPasswordResponse>(endpoint, request);
  }

  changePassword(request: SendPasswordRequest): Observable<ChangePasswordResponse> {
    const endpoint = `/${CONTROLLER_CONSTANTS.ACCOUNT}/${ENDPOINT_CONSTANTS.RESET_PASSWORD}`;
    return this.baseHttp.post<ChangePasswordResponse>(endpoint, request);
  }
}
